var map = {
	"./img/icon-arrow.png": 9350,
	"./img/icon-close.png": 2242,
	"./img/icon-end.png": 8284,
	"./img/icon-host.png": 8640,
	"./img/icon-leave.png": 1821,
	"./img/icon-like.png": 8839,
	"./img/icon-live.png": 8373,
	"./img/icon-num.png": 4172,
	"./img/icon-pause.png": 7726,
	"./img/icon-play-live.png": 2073,
	"./img/icon-play.png": 1686,
	"./img/icon-position.png": 1938,
	"./img/icon-time.png": 9290,
	"./img/icon-tip.png": 5466,
	"./img/icon-video.png": 7256,
	"./img/icon-watermark.png": 951,
	"./img/live-bg.png": 6341,
	"./music/demo.mp3": 9035
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5186;